module.exports = "<div class=\"tagline\" ng-hide=\"$root.isMember\">\n  <div class=\"centerwrap\">\n    <h3 ng-bind-html=\"main.siteConst.tagline.topLine\"></h3>\n    <p ng-bind-html=\"main.siteConst.tagline.secondLine\"></p>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./~/core_theme_2/src/templates/directives/tagline.html
// module id = 160
// module chunks = 0